// extracted by mini-css-extract-plugin
module.exports = {"block":"tooltip_block__dRP5m","tip":"tooltip_tip__nAEpR"};